import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTab } from '@angular/material/tabs';

@Component({
    selector: 'fi-mat-tab-bookmark-layout',
    template: `
        <mat-tab [label]="label">
            <ng-template matTabContent>
                <ng-content></ng-content>
            </ng-template>
        </mat-tab>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-mat-tab-bookmark-layout' },
    standalone: false,
})
export class FiMatTabBookmarkLayoutComponent {
    @ViewChild(MatTab) public matTab: MatTab;
    @Input() label: string;
}
